<template>
  <div>
    <v-form>
      <v-container>
        <h3>Organization</h3>
        <br />
        <!-- <v-row>
                  <v-col cols="12" xs="12" sm="6" md="4">
                    <v-select label="Hierarchy Group" :items="items" item-text="description" item-value="code" v-model="selectedHG"></v-select>
                  </v-col>
                </v-row> -->
        <!-- Payroll Location -->
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6">
            <span class="body-1 font-weight-bold">From</span>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6">
            <span class="body-1 font-weight-bold">To</span>
          </v-col>
        </v-row>
        <v-row :style="payLocChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Loc ID"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.locId"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Payroll Location"
              dense
              :class="classPadding"
              readonly
              :value="model.locName"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Loc ID"
              dense
              hint="To"
              persistent-hint
              :value="selectedPayLoc.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <payroll-location
              :class-padding="classPadding"
              :title="'Payroll Locations'"
              :label="'Payroll Location'"
              :required="true"
              v-model="selectedPayLoc"
              :code-value="false"
              :dense="true"
              :disable-lookup="activeH.payLoc"
              :param="activeH.payLocParam"
            ></payroll-location>
          </v-col>
        </v-row>
        <!-- Timekeep Group -->
        <v-row :style="tksChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.tkGroupCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Timekeep Group"
              dense
              :class="classPadding"
              readonly
              :value="model.tkGroupDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedTKGroup.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <tk-group
              :class-padding="classPadding"
              :title="'Timekeep Group'"
              :label="'Timekeep Group'"
              :required="true"
              v-model="selectedTKGroup"
              :code-value="false"
              :dense="true"
              v-if="
                genConfig.enableHierarchyOrgLevel &&
                  !genConfig.sapInfoTypesIntegration
              "
              :payroll-group="0"
              :disable-lookup="activeH.timekeep"
              :param="activeH.timekeepParam"
            ></tk-group>
            <tk-group
              :class-padding="classPadding"
              :title="'Timekeep Group'"
              :label="'Timekeep Group'"
              :required="true"
              v-model="selectedTKGroup"
              :code-value="false"
              :dense="true"
              v-else-if="
                genConfig.enableHierarchyOrgLevel &&
                  genConfig.sapInfoTypesIntegration
              "
              :payroll-group="0"
              :disable-lookup="activeH.timekeep"
              :param="activeH.timekeepParam"
              :branch="selectedBranch.code"
              :location="selectedLoc.code"
              :group="selectedGroup.code"
            ></tk-group>
            <tk-group
              :class-padding="classPadding"
              :title="'Timekeep Group'"
              :label="'Timekeep Group'"
              :required="true"
              v-model="selectedTKGroup"
              :code-value="false"
              :dense="true"
              v-else-if="!genConfig.isTKSEqualPayroll"
              :payroll-group="
                isNullOrUndefined(selectedPayLoc.code)
                  ? 0
                  : parseInt(selectedPayLoc.code)
              "
              :disable-lookup="activeH.timekeep"
              :param="activeH.timekeepParam"
            ></tk-group>
            <v-text-field
              label="Timekeep Group"
              dense
              :value="selectedTKGroup.desc"
              :class="classPadding"
              readonly
              v-else
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Project Code -->
        <v-row :style="projectCodeChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.projectCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Project Code"
              dense
              :class="classPadding"
              readonly
              :value="model.projectDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedProjectCode.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <project-code
              :class-padding="classPadding"
              :title="'Project File'"
              :label="'Project Code'"
              v-model="selectedProjectCode"
              :code-value="false"
              :dense="true"
              :required="procjectCodeRequired"
              :disable-lookup="activeH.projectCode"
              :param="activeH.projectCodeParam"
            ></project-code>
          </v-col>
        </v-row>

        <!-- Department -->
        <v-row :style="depChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.depCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Department"
              dense
              :class="classPadding"
              readonly
              :value="model.depDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedDep.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <department
              :class-padding="classPadding"
              :title="'Departments'"
              :label="'Department'"
              v-model="selectedDep"
              :code-value="false"
              :dense="true"
              :required="depRequired"
              :disable-lookup="activeH.department"
              :param="activeH.departmentParam"
            ></department>
          </v-col>
        </v-row>

        <!-- Division -->
        <v-row :style="divChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.divCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Division"
              dense
              :class="classPadding"
              readonly
              :value="model.divDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedDiv.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <division
              :class-padding="classPadding"
              :title="'Divisions'"
              :label="'Division'"
              v-model="selectedDiv"
              :code-value="false"
              :dense="true"
              :required="divRequired"
              :disable-lookup="activeH.division"
              :param="activeH.divisionParam"
            ></division>
          </v-col>
        </v-row>

        <!-- Branch -->
        <v-row :style="branchChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.braCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Branch"
              dense
              :class="classPadding"
              readonly
              :value="model.braDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedBranch.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <branch
              :class-padding="classPadding"
              :title="'Branches'"
              :label="'Branch'"
              v-model="selectedBranch"
              :code-value="false"
              :dense="true"
              :required="branchRequired"
              :disable-lookup="activeH.branch"
              :param="activeH.branchParam"
            ></branch>
          </v-col>
        </v-row>

        <!-- Section -->
        <v-row :style="sectionChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.secCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Section"
              dense
              :class="classPadding"
              readonly
              :value="model.secDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedSec.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <section-lookup
              :class-padding="classPadding"
              :title="'Sections'"
              :label="'Section'"
              v-model="selectedSec"
              :code-value="false"
              :dense="true"
              :required="sectionRequired"
              :disable-lookup="activeH.section"
              :param="activeH.sectionParam"
            ></section-lookup>
          </v-col>
        </v-row>

        <!-- Designation -->
        <v-row :style="desChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.desCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Designation"
              dense
              :class="classPadding"
              readonly
              :value="model.desDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedDesig.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <designation
              :class-padding="classPadding"
              :title="'Designation'"
              :label="'Designation'"
              v-model="selectedDesig"
              :code-value="false"
              :dense="true"
              :required="desRequired"
              :disable-lookup="activeH.designation"
              :param="activeH.designationParam"
            ></designation>
          </v-col>
        </v-row>
        <!-- Job Level -->
        <v-row :style="jobLevelChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.jobCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Job Level"
              dense
              :class="classPadding"
              readonly
              :value="model.jobDesc"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedDesig.jobCode"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Job Level"
              dense
              :class="classPadding"
              readonly
              :value="selectedDesig.jobDesc"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- Unit -->
        <v-row :style="unitChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.unitCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Unit"
              dense
              :class="classPadding"
              readonly
              :value="model.unitDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedUnit.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <unit
              :class-padding="classPadding"
              :title="'Units'"
              :label="'Unit'"
              v-model="selectedUnit"
              :code-value="false"
              :dense="true"
              :required="unitRequired"
              :disable-lookup="activeH.unit"
              :param="activeH.unitParam"
            ></unit>
          </v-col>
        </v-row>

        <!-- Area -->
        <v-row :style="areaChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.areaCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Area"
              dense
              :class="classPadding"
              readonly
              :value="model.areaDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedArea.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <area-lookup
              :class-padding="classPadding"
              :title="'Areas'"
              :label="'Area'"
              v-model="selectedArea"
              :code-value="false"
              :dense="true"
              :required="areaRequired"
              :disable-lookup="activeH.area"
              :param="activeH.areaParam"
            ></area-lookup>
          </v-col>
        </v-row>

        <!-- Location -->
        <v-row :style="locationChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.locationCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Location"
              dense
              :class="classPadding"
              readonly
              :value="model.locationDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedLoc.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <location
              :class-padding="classPadding"
              :title="'Locations'"
              :label="'Location'"
              v-model="selectedLoc"
              :code-value="false"
              :dense="true"
              :required="locationRequired"
              :disable-lookup="activeH.location"
              :param="activeH.locationParam"
            ></location>
          </v-col>
        </v-row>

        <!-- Employee Category -->
        <v-row :style="empCatChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.categoryCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Employee Category"
              dense
              :class="classPadding"
              readonly
              :value="model.categoryDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedEmpCat.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <emp-category
              :class-padding="classPadding"
              :title="'Employee Category'"
              :label="'Employee Category'"
              v-model="selectedEmpCat"
              :code-value="false"
              :dense="true"
              :required="empCatRequired"
              :disable-lookup="activeH.empCat"
              :param="activeH.empCatParam"
            ></emp-category>
          </v-col>
        </v-row>

        <!-- Rank -->
        <v-row :style="rankChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.rankCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Rank"
              dense
              :class="classPadding"
              readonly
              :value="model.rankDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedRank.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <rank
              :class-padding="classPadding"
              :title="'Rank'"
              :label="'Rank'"
              v-model="selectedRank"
              :code-value="false"
              :dense="true"
              :required="rankRequired"
              :disable-lookup="activeH.rank"
              :param="activeH.rankParam"
            ></rank>
          </v-col>
        </v-row>

        <!-- Group -->
        <v-row :style="groupChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.grpCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Group"
              dense
              :class="classPadding"
              readonly
              :value="model.grpDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedGroup.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <group
              :class-padding="classPadding"
              :title="'Group'"
              :label="'Group'"
              v-model="selectedGroup"
              :code-value="false"
              :dense="true"
              :required="groupRequired"
              :disable-lookup="activeH.group"
              :param="activeH.groupParam"
            ></group>
          </v-col>
        </v-row>

        <!-- Pay House -->
        <v-row :style="payHouseChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.subAcctCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Pay House"
              dense
              :class="classPadding"
              readonly
              :value="model.subAcctDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedPH.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <pay-house
              :class-padding="classPadding"
              :title="'Pay House'"
              :label="'Pay House'"
              v-model="selectedPH"
              :code-value="false"
              :dense="true"
              :required="payLocRequired"
              :disable-lookup="activeH.payHouse"
              :param="activeH.payHouseParam"
            ></pay-house>
          </v-col>
        </v-row>

        <!-- Employee Status -->
        <v-row :style="empStatChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.empStatCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Employee Status"
              dense
              :class="classPadding"
              readonly
              :value="model.empStatDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedEmpStat.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <emp-status
              :class-padding="classPadding"
              :title="'Employee Status'"
              :label="'Employee Status'"
              v-model="selectedEmpStat"
              :code-value="false"
              :dense="true"
              :required="empStatRequired"
              :disable-lookup="activeH.empStat"
              :param="activeH.empStatParam"
            ></emp-status>
          </v-col>
        </v-row>

        <!-- Tax Code -->
        <v-row :style="taxChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.taxCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Tax Status"
              dense
              :class="classPadding"
              readonly
              :value="model.taxDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedTax.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <tax-code
              :class-padding="classPadding"
              :title="'Tax Status'"
              :label="'Tax Status'"
              v-model="selectedTax"
              :code-value="false"
              :dense="true"
              :required="taxCodeRequired"
              :disable-lookup="activeH.tax"
              :param="activeH.taxParam"
            ></tax-code>
          </v-col>
        </v-row>
        <!-- Salary Classification -->
        <v-row :style="salClassChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.clsCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Salary Classification"
              dense
              :class="classPadding"
              readonly
              :value="model.clsDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedSal.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <salary-class
              :class-padding="classPadding"
              :title="'Salary Classification'"
              :label="'Salary Classification'"
              v-model="selectedSal"
              :code-value="false"
              :dense="true"
              :required="salaryClassRequired"
              :disable-lookup="activeH.salClass"
              :param="activeH.salClassParam"
            ></salary-class>
          </v-col>
        </v-row>

        <!-- Region -->
        <v-row :style="regionChanged ? style : ''">
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="From"
              persistent-hint
              :class="classPadding"
              readonly
              :value="model.alphaRegCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Region"
              dense
              :class="classPadding"
              readonly
              :value="model.alphaRegDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2">
            <v-text-field
              label="Code"
              dense
              hint="To"
              persistent-hint
              :value="selectedReg.code"
              :class="classPadding"
              readonly
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4">
            <region
              :class-padding="classPadding"
              :title="'Region'"
              :label="'Region'"
              v-model="selectedReg"
              :code-value="false"
              :dense="true"
              :required="regionRequired"
              :disableLookup="activeH.region"
              :param="activeH.regionParam"
            ></region>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import { isNullOrUndefined } from "../../../validation/validation";
import isEmpty from "lodash/isEmpty";
const PayrollLocation = () =>
  import("../../setup/general/payroll-location/Lookup");
const TkGroup = () => import("../../others/TKGroupLookup");
const ProjectCode = () =>
  import(
    "../../setup/employment-other-info/others/project-file/project-list/Lookup"
  );
const Department = () =>
  import("../../setup/employment-info/organizational-level/department/Lookup");
const Division = () =>
  import("../../setup/employment-info/organizational-level/division/Lookup");
const Branch = () =>
  import("../../setup/employment-info/organizational-level/branch/Lookup");
const Section = () =>
  import("../../setup/employment-info/organizational-level/section/Lookup");
const Designation = () =>
  import("../../setup/employment-info/employee-level/designation/Lookup");
const Unit = () =>
  import("../../setup/employment-info/organizational-level/unit/Lookup");
const AreaLookup = () =>
  import("../../setup/employment-info/organizational-level/area/Lookup");
const Location = () =>
  import("../../setup/employment-info/organizational-level/location/Lookup");
const EmpCategory = () =>
  import("../../setup/employment-info/employee-level/employee-category/Lookup");
const Rank = () =>
  import("../../setup/employment-info/employee-level/rank/Lookup");
const Group = () =>
  import("../../setup/employment-info/organizational-level/group/Lookup");
const PayHouse = () =>
  import("../../setup/employment-info/organizational-level/pay-house/Lookup");
const EmpStatus = () =>
  import("../../setup/employment-info/employee-level/employee-status/Lookup");
const TaxCode = () => import("../../setup/general/tax-status/Lookup");
const SalaryClass = () =>
  import(
    "../../setup/employment-info/employee-level/salary-classification/Lookup"
  );
const Region = () => import("../../setup/personal-information/region/Lookup");

import empInfoMixin from "./mixins/empInfoMixins";
const API_ENDPOINT = "/api/employmentInfo";
const API_ENDPOINT_HG = "/api/hierarchyGroup";
export default {
  mixins: [empInfoMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    activeH: {},
    items: [],
    selectedHG: null,
    // selectedPayLoc: {},
    // selectedTKGroup: {},
    // selectedProjectCode: {},
    // selectedDep: {},
    // selectedDiv: {},
    // selectedBranch: {},
    // selectedSec: {},
    // selectedDesig: {},
    // selectedUnit: {},
    // selectedArea: {},
    // selectedLoc: {},
    // selectedEmpCat: {},
    // selectedRank: {},
    // selectedGroup: {},
    // selectedPH: {},
    // selectedEmpStat: {},
    // selectedTax: {},
    // selectedSal: {},
    // selectedReg: {},
    //model: {}
  }),
  components: {
    PayrollLocation,
    ProjectCode,
    Department,
    Division,
    Branch,
    SectionLookup: Section,
    Designation,
    Unit,
    AreaLookup,
    Location,
    EmpCategory,
    Rank,
    Group,
    PayHouse,
    EmpStatus,
    TaxCode,
    SalaryClass,
    Region,
    TkGroup,
  },
  computed: {
    ...mapFields("pme", ["empCode"]),
    ...mapFields("pmeEmployment", [
      "selectedPayLoc",
      "selectedTKGroup",
      "selectedProjectCode",
      "selectedDep",
      "selectedDiv",
      "selectedBranch",
      "selectedSec",
      "selectedDesig",
      "selectedUnit",
      "selectedArea",
      "selectedLoc",
      "selectedEmpCat",
      "selectedRank",
      "selectedGroup",
      "selectedPH",
      "selectedEmpStat",
      "selectedTax",
      "selectedSal",
      "selectedReg",
      "model",
    ]),
    ...mapFields("pmeMovementType", {
      pmt: "model",
    }),
    ...mapFields("pmeBasicSalary", {
      pbs: "model",
      basicSalary: "basicSalary",
    }),
    ...mapFields("pmeAllowance", ["allowances"]),
    ...mapFields("pmeEarnings", ["earnings"]),
    ...mapState("config", {
      genConfig: (state) => state.genConfig,
    }),
    style() {
      return "background-color: greenyellow;";
    },
    payLocChanged() {
      return !this.isEqual(this.selectedPayLoc.code, this.model.locId);
    },
    tksChanged() {
      // return !this.isEqual(
      //   this.selectedTKGroup.code,
      //   isNullOrUndefined(this.model.tkGroupCode) ? null :  parseInt(this.model.tkGroupCode)
      // );
      return !this.isEqual(this.selectedTKGroup.code, this.model.tkGroupCode);
    },
    projectCodeChanged() {
      return !this.isEqual(
        this.selectedProjectCode.code,
        this.model.projectCode
      );
    },
    depChanged() {
      return !this.isEqual(this.selectedDep.code, this.model.depCode);
    },
    divChanged() {
      return !this.isEqual(this.selectedDiv.code, this.model.divCode);
    },
    branchChanged() {
      return !this.isEqual(this.selectedBranch.code, this.model.braCode);
    },
    sectionChanged() {
      return !this.isEqual(this.selectedSec.code, this.model.secCode);
    },
    desChanged() {
      return !this.isEqual(this.selectedDesig.code, this.model.desCode);
    },
    jobLevelChanged() {
      return !this.isEqual(this.selectedDesig.jobCode, this.model.jobCode);
    },
    unitChanged() {
      return !this.isEqual(this.selectedUnit.code, this.model.unitCode);
    },
    areaChanged() {
      return !this.isEqual(this.selectedArea.code, this.model.areaCode);
    },
    locationChanged() {
      return !this.isEqual(this.selectedLoc.code, this.model.locationCode);
    },
    empCatChanged() {
      return !this.isEqual(this.selectedEmpCat.code, this.model.categoryCode);
    },
    rankChanged() {
      return !this.isEqual(this.selectedRank.code, this.model.rankCode);
    },
    groupChanged() {
      return !this.isEqual(this.selectedGroup.code, this.model.grpCode);
    },
    payHouseChanged() {
      return !this.isEqual(this.selectedPH.code, this.model.subAcctCode);
    },
    empStatChanged() {
      return !this.isEqual(this.selectedEmpStat.code, this.model.empStatCode);
    },
    taxChanged() {
      return !this.isEqual(this.selectedTax.code, this.model.taxCode);
    },
    salClassChanged() {
      return !this.isEqual(this.selectedSal.code, this.model.clsCode);
    },
    regionChanged() {
      return !this.isEqual(this.selectedReg.code, this.model.alphaRegCode);
    },
    hierarchySetup() {},
  },
  methods: {
    isNullOrUndefined,
    ...mapActions("config", ["getGenConfig"]),
    getEmploymentInfo(empCode) {
      this.$axios
        .get(`${API_ENDPOINT}/${empCode}`)
        .then(({ data }) => {
          this.model = data;
          this.setEmploymentInfo(data);
        })
        .catch(({ response }) => {
          this.toast.error(response.data.message);
        });
    },
    setEmploymentInfo(model) {
      this.selectedPayLoc = {
        code: isNullOrUndefined(model.locId) ? null : model.locId,
        desc: isNullOrUndefined(model.locName) ? null : model.locName,
      };
      this.selectedTKGroup = {
        code: isNullOrUndefined(model.tkGroupCode) ? null : model.tkGroupCode,
        desc: isNullOrUndefined(model.tkGroupDesc) ? null : model.tkGroupDesc,
      };

      this.selectedProjectCode = {
        code: isNullOrUndefined(model.projectCode) ? null : model.projectCode,
        desc: isNullOrUndefined(model.projectDesc) ? null : model.projectDesc,
      };

      this.selectedDep = {
        code: isNullOrUndefined(model.depCode) ? null : model.depCode,
        desc: isNullOrUndefined(model.depDesc) ? null : model.depDesc,
      };

      this.selectedDiv = {
        code: isNullOrUndefined(model.divCode) ? null : model.divCode,
        desc: isNullOrUndefined(model.divDesc) ? null : model.divDesc,
      };

      this.selectedBranch = {
        code: isNullOrUndefined(model.braCode) ? null : model.braCode,
        desc: isNullOrUndefined(model.braDesc) ? null : model.braDesc,
      };

      this.selectedSec = {
        code: isNullOrUndefined(model.secCode) ? null : model.secCode,
        desc: isNullOrUndefined(model.secDesc) ? null : model.secDesc,
      };

      this.selectedDesig = {
        code: isNullOrUndefined(model.desCode) ? null : model.desCode,
        desc: isNullOrUndefined(model.desDesc) ? null : model.desDesc,
        jobCode: isNullOrUndefined(model.jobCode) ? null : model.jobCode,
        jobDesc: isNullOrUndefined(model.jobDesc) ? null : model.jobDesc,
      };

      this.selectedUnit = {
        code: isNullOrUndefined(model.unitCode) ? null : model.unitCode,
        desc: isNullOrUndefined(model.unitDesc) ? null : model.unitDesc,
      };

      this.selectedArea = {
        code: isNullOrUndefined(model.areaCode) ? null : model.areaCode,
        desc: isNullOrUndefined(model.areaDesc) ? null : model.areaDesc,
      };

      this.selectedLoc = {
        code: isNullOrUndefined(model.locationCode) ? null : model.locationCode,
        desc: isNullOrUndefined(model.locationDesc) ? null : model.locationDesc,
      };

      this.selectedEmpCat = {
        code: isNullOrUndefined(model.categoryCode) ? null : model.categoryCode,
        desc: isNullOrUndefined(model.categoryDesc) ? null : model.categoryDesc,
      };

      this.selectedRank = {
        code: isNullOrUndefined(model.rankCode) ? null : model.rankCode,
        desc: isNullOrUndefined(model.rankDesc) ? null : model.rankDesc,
      };

      this.selectedGroup = {
        code: isNullOrUndefined(model.grpCode) ? null : model.grpCode,
        desc: isNullOrUndefined(model.grpDesc) ? null : model.grpDesc,
      };

      this.selectedPH = {
        code: isNullOrUndefined(model.subAcctCode) ? null : model.subAcctCode,
        desc: isNullOrUndefined(model.subAcctDesc) ? null : model.subAcctDesc,
      };

      this.selectedEmpStat = {
        code: isNullOrUndefined(model.empStatCode) ? null : model.empStatCode,
        desc: isNullOrUndefined(model.empStatDesc) ? null : model.empStatDesc,
      };

      this.selectedTax = {
        code: isNullOrUndefined(model.taxCode) ? null : model.taxCode,
        desc: isNullOrUndefined(model.taxDesc) ? null : model.taxDesc,
      };
      this.selectedSal = {
        code: isNullOrUndefined(model.clsCode) ? null : model.clsCode,
        desc: isNullOrUndefined(model.clsDesc) ? null : model.clsDesc,
      };

      this.selectedReg = {
        code: isNullOrUndefined(model.alphaRegCode) ? null : model.alphaRegCode,
        desc: isNullOrUndefined(model.alphaRegDesc) ? null : model.alphaRegDesc,
      };
    },
    isEqual(arg1, arg2) {
      if (isNullOrUndefined(arg1) && isNullOrUndefined(arg2)) return true;
      return arg1 === arg2 ? true : false;
    },
    getHierarchy() {
      if (!isNullOrUndefined(this.selectedPayLoc.code)) {
        this.$axios
          .post(`/api/pmeLevel/hierarchy`, {
            LocId: this.selectedPayLoc.code,
            EffectDate: isNullOrUndefined(this.pmt.effectDate)
              ? ""
              : moment(this.pmt.effectDate).format("MM/DD/YYYY"),
            MovementTypeFrom: isNullOrUndefined(this.pmt.from)
              ? ""
              : moment(this.pmt.from).format("MM/DD/YYYY"),
          })
          .then(({ data }) => {
            if (!isEmpty(data)) {
              this.$set(this.selectedDiv, "code", data.divCode);
              this.$set(this.selectedDiv, "desc", data.divDesc);

              this.$set(this.selectedArea, "code", data.areaCode);
              this.$set(this.selectedArea, "desc", data.areaDesc);

              this.$set(this.selectedDep, "code", data.depCode);
              this.$set(this.selectedDep, "desc", data.depDesc);

              this.$set(this.selectedSec, "code", data.secCode);
              this.$set(this.selectedSec, "desc", data.secDesc);

              this.$set(this.selectedProjectCode, "code", data.projectCode);
              this.$set(this.selectedProjectCode, "desc", data.projectDesc);

              this.$set(this.selectedGroup, "code", data.grpCode);
              this.$set(this.selectedGroup, "desc", data.grpDesc);

              this.$set(this.selectedReg, "code", data.regionCode);
              this.$set(this.selectedReg, "desc", data.regionDesc);

              this.$set(this.selectedBranch, "code", data.branchCode);
              this.$set(this.selectedBranch, "desc", data.branchDesc);

              this.$set(this.selectedUnit, "code", data.unitCode);
              this.$set(this.selectedUnit, "desc", data.unitDesc);

              this.$set(this.selectedLoc, "code", data.locationCode);
              this.$set(this.selectedLoc, "desc", data.locationDesc);

              this.$set(this.selectedPH, "code", data.subAcctCode);
              this.$set(this.selectedPH, "desc", data.subAcctDesc);

              this.$set(this.pmt, "withSalary", data.withSalary);
              // this.$set(this.pbs, 'basicSalary', data.basicSalary)
              this.basicSalary = data.basicSalary;
              // Object.assign({}, this.selectedDiv, { code: data.divCode, desc: data.divDesc })
              // Object.assign({}, this.selectedArea, { code: data.areaCode, desc: data.areaDesc })
              // Object.assign({}, this.selectedDep, { code: data.depCode, desc: data.depDesc })
              // Object.assign({}, this.selectedSec, { code: data.secCode, desc: data.secDesc })
              // Object.assign({}, this.selectedProjectCode, { code: data.projectCode, desc: data.projectDesc })
              // Object.assign({}, this.selectedGroup, { code: data.grpCode, desc: data.grpDesc })
              // Object.assign({}, this.selectedReg, { code: data.regionCode, desc: data.regionDesc })
              // Object.assign({}, this.selectedBranch, { code: data.branchCode, desc: data.branchDesc })
              // Object.assign({}, this.selectedUnit, { code: data.unitCode, desc: data.unitDesc })
              // Object.assign({}, this.selectedLoc, { code: data.locationCode, desc: data.locationDesc })
              // Object.assign({}, this.selectedPH, { code: data.subAcctCode, desc: data.subAcctDesc })
            }
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          });
      }
    },
    getGOLByLevel(level) {
      this.$axios
        .get(`${API_ENDPOINT_HG}/gol/level/${level}`)
        .then(({ data }) => {
          // console.log(data);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getActiveHierarchy() {
      // console.log(this.selectedTKGroup)
      var paramData = {
        // GroupCode: this.selectedHG,
        selectedPayLoc: this.selectedPayLoc,
        selectedTKGroup: this.selectedTKGroup,
        selectedProjectCode: this.selectedProjectCode,
        selectedDep: this.selectedDep,
        selectedDiv: this.selectedDiv,
        selectedBranch: this.selectedBranch,
        selectedSec: this.selectedSec,
        selectedDesig: this.selectedDesig,
        selectedUnit: this.selectedUnit,
        selectedArea: this.selectedArea,
        selectedLoc: this.selectedLoc,
        selectedEmpCat: this.selectedEmpCat,
        selectedRank: this.selectedRank,
        selectedGroup: this.selectedGroup,
        selectedPH: this.selectedPH,
        selectedEmpStat: this.selectedEmpStat,
        selectedTax: this.selectedTax,
        selectedSal: this.selectedSal,
        selectedReg: this.selectedReg,
      };
      this.$axios
        .post(`${API_ENDPOINT_HG}/details/activeHierarchy`, paramData)
        .then(({ data }) => {
          // console.log(data);
          this.activeH = data;
          this.setHierarchyValue(data.hierarchyValue);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getHierarchyGroup() {
      this.$axios
        .get(`${API_ENDPOINT_HG}`)
        .then(({ data }) => {
          this.items = data;
          if (data.length > 0) {
            this.selectedHG = data[0].code;
            this.getActiveHierarchy();
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    setHierarchyValue(data) {
      var {
        selectedPayLoc,
        selectedTKGroup,
        selectedProjectCode,
        selectedDep,
        selectedDiv,
        selectedBranch,
        selectedSec,
        selectedDesig,
        selectedJobLevel,
        selectedUnit,
        selectedArea,
        selectedLoc,
        selectedEmpCat,
        selectedRank,
        selectedGroup,
        selectedPH,
        selectedEmpStat,
        selectedTax,
        selectedSal,
        selectedReg,
      } = data;

      if (!isEmpty(selectedPayLoc)) {
        if (this.isNullOrUndefined(selectedPayLoc.code)) {
          this.selectedPayLoc = {};
        } else {
          this.selectedPayLoc = {
            code: selectedPayLoc.code,
            desc: selectedPayLoc.desc,
          };
        }
      } else this.selectedPayLoc = {};

      // else
      //   this.selectedPayLoc = {}
      if (!isEmpty(selectedTKGroup)) {
        if (this.isNullOrUndefined(selectedTKGroup.code)) {
          this.selectedTKGroup = {};
        } else {
          this.selectedTKGroup = {
            code: selectedTKGroup.code,
            desc: selectedTKGroup.desc,
          };
        }
      } else this.selectedTKGroup = {};

      if (!isEmpty(selectedProjectCode)) {
        if (this.isNullOrUndefined(selectedProjectCode.code)) {
          this.selectedProjectCode = {};
        } else {
          this.selectedProjectCode = selectedProjectCode;
        }
      } else this.selectedProjectCode = {};

      if (!isEmpty(selectedDep)) {
        if (this.isNullOrUndefined(selectedDep.code)) {
          this.selectedDep = {};
        } else {
          this.selectedDep = selectedDep;
        }
      } else this.selectedDep = {};

      if (!isEmpty(selectedDiv)) {
        if (this.isNullOrUndefined(selectedDiv.code)) {
          this.selectedDiv = {};
        } else {
          this.selectedDiv = selectedDiv;
        }
      } else this.selectedDiv = {};

      if (!isEmpty(selectedBranch)) {
        if (this.isNullOrUndefined(selectedBranch.code)) {
          this.selectedBranch = {};
        } else {
          this.selectedBranch = selectedBranch;
        }
      } else this.selectedBranch = {};

      if (!isEmpty(selectedSec)) {
        if (this.isNullOrUndefined(selectedSec.code)) {
          this.selectedSec = {};
        } else {
          this.selectedSec = selectedSec;
        }
      } else this.selectedSec = {};

      if (!isEmpty(selectedDesig)) {
        if (this.isNullOrUndefined(selectedDesig.code)) {
          this.selectedDesig = {};
        } else {
          this.selectedDesig = selectedDesig;
          this.$set(this.selectedDesig, "jobCode", selectedJobLevel.code);
          this.$set(this.selectedDesig, "jobDesc", selectedJobLevel.desc);
        }
      } else this.selectedDesig = {};

      if (!isEmpty(selectedUnit)) {
        if (this.isNullOrUndefined(selectedUnit.code)) {
          this.selectedUnit = {};
        } else {
          this.selectedUnit = selectedUnit;
        }
      } else this.selectedUnit = {};

      if (!isEmpty(selectedArea)) {
        if (this.isNullOrUndefined(selectedArea.code)) {
          this.selectedArea = {};
        } else {
          this.selectedArea = selectedArea;
        }
      } else this.selectedArea = {};

      if (!isEmpty(selectedLoc)) {
        if (this.isNullOrUndefined(selectedLoc.code)) {
          this.selectedLoc = {};
        } else {
          this.selectedLoc = selectedLoc;
        }
      } else this.selectedLoc = {};

      if (!isEmpty(selectedEmpCat)) {
        if (this.isNullOrUndefined(selectedEmpCat.code)) {
          this.selectedEmpCat = {};
        } else {
          this.selectedEmpCat = selectedEmpCat;
        }
      } else this.selectedEmpCat = {};

      if (!isEmpty(selectedRank)) {
        if (this.isNullOrUndefined(selectedRank.code)) {
          this.selectedRank = {};
        } else {
          this.selectedRank = selectedRank;
        }
      } else this.selectedRank = {};

      if (!isEmpty(selectedGroup)) {
        if (this.isNullOrUndefined(selectedGroup.code)) {
          this.selectedGroup = {};
        } else {
          this.selectedGroup = selectedGroup;
        }
      } else this.selectedGroup = {};

      if (!isEmpty(selectedPH)) {
        if (this.isNullOrUndefined(selectedPH.code)) {
          this.selectedPH = {};
        } else {
          this.selectedPH = selectedPH;
        }
      } else this.selectedPH = {};

      if (!isEmpty(selectedEmpStat)) {
        if (this.isNullOrUndefined(selectedEmpStat.code)) {
          this.selectedEmpStat = {};
        } else {
          this.selectedEmpStat = selectedEmpStat;
        }
      } else this.selectedEmpStat = {};

      if (!isEmpty(selectedTax)) {
        if (this.isNullOrUndefined(selectedTax.code)) {
          this.selectedTax = {};
        } else {
          this.selectedTax = selectedTax;
        }
      } else this.selectedTax = {};

      if (!isEmpty(selectedSal)) {
        if (this.isNullOrUndefined(selectedSal.code)) {
          this.selectedSal = {};
        } else {
          this.selectedSal = selectedSal;
        }
      } else this.selectedSal = {};

      if (!isEmpty(selectedReg)) {
        if (this.isNullOrUndefined(selectedReg.code)) {
          this.selectedReg = {};
        } else {
          this.selectedReg = selectedReg;
        }
      } else this.selectedReg = {};
    },
    callActiveHierarchy(current, old) {
      if (!isEmpty(current)) {
        if (
          !this.isNullOrUndefined(current.code) ||
          !this.isNullOrUndefined(old.code)
        ) {
          if (current.code !== old.code) {
            this.getActiveHierarchy();
            //console.log('designation')
          }
        }
      }
    },
  },
  created() {
    // this.getHierarchyGroup();

    this.getActiveHierarchy();
    this.getGenConfig();

    if (this.empCode) {
      this.getEmploymentInfo(this.empCode);
    }
  },
  watch: {
    selectedPayLoc(val, oldVal) {
      if (this.genConfig.isTKSEqualPayroll) {
        this.selectedTKGroup = Object.assign({}, val);
        if (!isNullOrUndefined(this.selectedTKGroup.code)) {
          this.selectedTKGroup.code = this.selectedTKGroup.code.toString();
        }
      }
      this.callActiveHierarchy(val, oldVal);
    },
    selectedTKGroup(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedProjectCode(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedDep(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedDiv(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedBranch(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedSec(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedDesig(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
      //this.getActiveHierarchy();
    },
    selectedUnit(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedArea(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedLoc(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedEmpCat(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedRank(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedGroup(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedPH(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedEmpStat(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedTax(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedSal(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    selectedReg(val, oldVal) {
      this.callActiveHierarchy(val, oldVal);
    },
    empCode(val) {
      if (!isNullOrUndefined(val)) {
        this.getEmploymentInfo(val);
      } else {
        this.model = {};
        this.selectedPayLoc = {};

        this.selectedTKGroup = {};

        this.selectedProjectCode = {};

        this.selectedDep = {};

        this.selectedDiv = {};

        this.selectedBranch = {};

        this.selectedSec = {};

        this.selectedDesig = {};

        this.selectedUnit = {};

        this.selectedArea = {};

        this.selectedLoc = {};

        this.selectedEmpCat = {};

        this.selectedRank = {};

        this.selectedGroup = {};

        this.selectedPH = {};

        this.selectedEmpStat = {};

        this.selectedTax = {};
        this.selectedSal = {};

        this.selectedReg = {};
      }
    },
  },
};
</script>
